export function withCustomHook<P>(callback: (props: P) => any) {
  // eslint-disable-next-line react/display-name
  return (Component: any) => (props: P) => {
    const customHooksData = callback(props);

    return <Component {...props} {...customHooksData} />;
  };
}
